import React from "react";

const Community = () => {
  return (
    <section className="community">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-12 comm-left">
            <h1 className="banner-heading">Join our Good Good Community</h1>
            {/* <p className="banner-text">
              sdf ggrtsr eruthguirghghbrt r trhg r grgh
            </p> */}
          </div>
          <div className="col-lg-6 col-12 comm-right">
            <div className="enquiry text-left">
              <form>
              <iframe title="Join our Good Good Community Form" frameBorder="0" style={{height:'780px',width:'99%',border:'none'}} src='https://forms.zohopublic.in/goodgoodpiggy/form/Website/formperma/8EfPGuQnJ_rVjoZcWhLbuel2GBrlSqh7G9R5CppwV7Y'></iframe>
                <div className="form-row">
                  {/* <div className="form-group col-12 text-center">
                    <div dangerouslySetInnerHTML={{ __html: zohoForm }} />
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;
